import { AreaAction, AreaState } from 'store/data/area';
import { domainUtility } from 'utility';

const initialState: AreaState = { allIds: [], byId: {} };

const areaReducer = (
  state: AreaState = initialState,
  action: AreaAction,
): AreaState => {
  switch (action.type) {
    case 'data/area/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/area/SET':
      return domainUtility.set(state, action.payload);
    case 'data/area/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/area/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/area/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default areaReducer;
